import React from 'react';
import { Phone, X } from 'lucide-react';

interface CallPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export function CallPopup({ isOpen, onClose }: CallPopupProps) {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '40px',
        minWidth: '320px',
        maxWidth: '400px',
        textAlign: 'center',
        position: 'relative',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '50%',
            color: '#666',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <X size={20} />
        </button>
        
        <div style={{
          width: '80px',
          height: '80px',
          backgroundColor: 'black',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px auto',
        }}>
          <Phone size={40} color="white" />
        </div>
        
        <h2 style={{
          margin: '0 0 8px 0',
          fontSize: '24px',
          fontWeight: '600',
          color: '#333',
        }}>
          Contact us
        </h2>
        
        <p style={{
          margin: '0 0 24px 0',
          color: '#666',
          fontSize: '16px',
        }}>
          Call or send us a text for information, or to book a lesson, and we'll get right back to you!
        </p>
        
        <a
          href="tel:(978) 443-4411"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px 24px',
            backgroundColor: 'black',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '12px',
            fontSize: '18px',
            fontWeight: '600',
            gap: '8px',
            transition: 'transform 0.2s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          <Phone size={20} />
          (978) 443-4411
        </a>
      </div>
    </div>
  );
}